module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "animated",
    class: _vm.cname
  }, [_vm._l((_vm.buttons), function(b) {
    return _c('li', [_c('a', {
      class: b.icon,
      attrs: {
        "href": "",
        "data-type": b.code,
        "data-tagname": b.tagname,
        "data-value": b.value
      }
    }), _vm._v(" "), (b.sub) ? _c('ul', {
      staticClass: "plekan-submenu"
    }, _vm._l((b.sub), function(s) {
      return _c('li', [_c('a', {
        class: s.icon,
        attrs: {
          "href": "",
          "data-type": s.code,
          "data-tagname": s.tagname,
          "data-value": s.value
        }
      })])
    })) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.custom), function(c) {
    return _c('li', _vm._l((_vm.$customEditorButtons), function(b, key) {
      return _c('a', {
        class: b.class,
        attrs: {
          "href": "",
          "data-type": b.code || 'custom',
          "data-index": key
        }
      })
    }))
  }), _vm._v(" "), _vm._t("link")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58cd96a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editorList.vue
// module id = 114
// module chunks = 0